import {
  AppBar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from 'react';
import AccountCircle from '@mui/icons-material/AccountCircle';
import useLogoutLazy from '@src/adapters/hooks/useLogout';
import { useAuth } from '@src/auth/hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { Routes } from '@src/navigation/Routes';
import Breadcrumbs from '@src/navigation/Breadcrumbs';
import { useMenu } from '@src/providers/MenuProvider';
interface Props {
  toggleMenu(): void;
}

function TopBar({ toggleMenu }: Props) {
  const navigate = useNavigate();
  const { menuWidth } = useMenu();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { setAccessToken, setLoggedInUser } = useAuth();
  const { execute: logout } = useLogoutLazy();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onLogout = async () => {
    setAccessToken(undefined);
    setLoggedInUser(null);
    try {
      await logout();
    } catch (e) {
    } finally {
      navigate(Routes.Login);
    }
  };

  return (
    <AppBar
      position="relative"
      sx={(theme) => ({
        boxShadow: 'none',
        backgroundColor: theme.palette.background.default,
        transition: theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        height: theme.spacing(8),
        width: `calc(100vw - ${menuWidth}px)`,
      })}>
      <Toolbar>
        <Box>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={toggleMenu}
            edge="start"
            sx={(theme) => ({
              marginRight: theme.spacing(2),
              color: 'rgba(1, 4, 13, 0.5)',
              height: '44px',
            })}
            size="large">
            <MenuIcon />
          </IconButton>
        </Box>
        <Breadcrumbs />
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}>
          <IconButton aria-label="logout" onClick={handleClick} size="large">
            <AccountCircle
              sx={(theme) => ({
                fill: theme.palette.action.active,
              })}></AccountCircle>
          </IconButton>
          <Menu
            id="toolbar-menu"
            anchorEl={anchorEl}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}>
            <MenuItem onClick={onLogout}>Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default TopBar;
